module.exports = __webpack_public_path__ + "static/media/Z icon.12b02799.svg";